import axios from 'axios';

/** Same-origin when empty (Apache proxies /api/ to faircorp-api). Set only if API is on another host. */
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? '',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' },
});

export interface IntakePayload {
  type: 'partnership' | 'position';
  name: string;
  contact: string;
  details: string;
  website?: string;
  partnershipType?: string;
  industry?: string;
  role?: string;
  experience?: string;
  portfolio?: string;
}

export interface TicketPayload {
  sector: 'Engineering' | 'Operations' | 'Infrastructure' | 'Sales' | 'Support' | 'Other';
  priority: 'Low' | 'Medium' | 'High' | 'Outage';
  contact: string;
  description: string;
  title?: string;
}

export function submitIntake(payload: IntakePayload) {
  return api.post<{ message: string }>('/api/intake', payload);
}

export function submitTicket(payload: TicketPayload) {
  return api.post<{ message: string }>('/api/ticket', payload);
}

/**
 * Canonical public visits endpoint. Same-origin `/api` on live fair-corp.com is
 * api-lite (no visits route). Only hosting.fair-corp.com proxies to faircorp-api.
 */
const HOSTING_VISITS_URL = 'https://hosting.fair-corp.com/api/hosting/visits';

export function incrementHostingVisit(siteKey: string) {
  return fetch(HOSTING_VISITS_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ siteKey }),
    mode: 'cors',
    credentials: 'omit',
    keepalive: true,
  });
}

/** One POST per JS realm. Survives React StrictMode double-mount; resets on hard refresh. */
let documentVisitSent = false;

export function recordHostingDocumentVisit(siteKey: string) {
  if (documentVisitSent) return;
  documentVisitSent = true;
  incrementHostingVisit(siteKey).catch(() => {});
}

export default api;
